import * as React from 'react';

import { VectorContainer } from '@/modules/auth';
import FormsContainer from '@/modules/auth/components/FormsContainer';
import { IAuthTypes } from '@/modules/auth/context';

const Authenticate: React.FC<{
  authType: IAuthTypes;
}> = ({ authType }) => {
  return (
    <main>
      <section className='relative flex h-screen gap-0'>
        <FormsContainer authType={authType} />
        <VectorContainer />
      </section>
    </main>
  );
};
export default Authenticate;
